import type Maybe from 'graphql/tsutils/Maybe';
import { isNumber } from 'lodash';

import GrowthEpicClient from 'bundles/epic/clients/Growth';

type CourseMaterial = {
  totalDuration?: Maybe<string>;
};
function getCourseAdjustedLearningHoursExperimentData<T extends CourseMaterial>(
  material: Maybe<T>,
  learningHoursOverride: number | null
): Maybe<T> {
  const learningHoursEnabled = GrowthEpicClient.get('learningHours');

  if (!learningHoursEnabled || !material || !learningHoursOverride || !isNumber(learningHoursOverride)) return material;

  return {
    ...material,
    totalDuration: `PT${Math.max(Math.round(learningHoursOverride), 1)}H`,
  };
}

type SpecializationData = {
  id: string;
  totalLearningHours?: Maybe<number>;
  learningHoursPerWeek?: Maybe<number>;
};
function getS12nAdjustedLearningHoursExperimentData<T extends SpecializationData>(
  data: Maybe<T>,
  totalLearningHours: number | null
): Maybe<T> {
  const learningHoursEnabled = GrowthEpicClient.get('learningHours');
  if (!learningHoursEnabled || !data || !totalLearningHours || !isNumber(totalLearningHours)) return data;

  return {
    ...data,
    totalLearningMonths: totalLearningHours / 40,
    learningHoursPerWeek: 10,
  };
}

export { getCourseAdjustedLearningHoursExperimentData, getS12nAdjustedLearningHoursExperimentData };
